import axios from 'axios';
import { TreatmentCategory } from '../types/treatmen-category.type';

// GET CATEGORIES
// /ewosapi/v1/shrimps/Feed/${globalCompanyId}/brand
export const getCategories = async (globalCompanyId: string): Promise<TreatmentCategory[]> => {
  const res = await axios.get(`/ewosapi/v1/shrimps/Treatment/${globalCompanyId}/category`);
  return res.data;
};
